import {DeleteOutlined} from "@ant-design/icons";
import React from "react";
import TableButton, {FMTableActionProps} from "./TableButton";

const TableDeleteButton = ({record, action, dataTestId, disabled}: FMTableActionProps) => {
    return (
        <TableButton record={record}
                     action={action}
                     dataTestId={dataTestId}
                     disabled={disabled}
                     icon={<DeleteOutlined style={{fontSize: '16px', color: '#666666'}}/>}

        />
    )
}

export default TableDeleteButton;